var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ic-form__connection" }, [
    _c("h3", [_vm._v(_vm._s(_vm.label))]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("IcFormRowWrapper", {
            attrs: {
              rowElement: "IcFormRow",
              id: _vm.name + "departureStation",
              name: _vm.name + ".departureStation",
              aria: _vm.$t("aria_required"),
              label: _vm.$t("label_departureStation"),
              labelWidth: 4,
              controlWidth: 8,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ validator }) {
                  return [
                    _c("IcStationTypeahead", {
                      attrs: {
                        id: _vm.name + "departureStation",
                        valueField: "n",
                        noMeta: 1,
                        icStation: -1,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.emitInput1(_vm.data, validator)
                        },
                        idStation: _vm.getDepartureStationId,
                      },
                      model: {
                        value: _vm.data.departureStation,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "departureStation", $$v)
                        },
                        expression: "data.departureStation",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("IcFormRowWrapper", {
            attrs: {
              rowElement: "IcFormRow",
              id: "arrivalStation",
              name: _vm.name + ".arrivalStation",
              aria: _vm.$t("aria_required"),
              label: _vm.$t("label_arrivalStation"),
              labelWidth: 4,
              controlWidth: 8,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ validator }) {
                  return [
                    _c("IcStationTypeahead", {
                      attrs: {
                        id: "arrivalStation",
                        name: _vm.name + ".arrivalStation",
                        valueField: "n",
                        noMeta: 1,
                        icStation: -1,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.emitInput1(_vm.data, validator)
                        },
                        idStation: _vm.getArrivalStationId,
                      },
                      model: {
                        value: _vm.data.arrivalStation,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "arrivalStation", $$v)
                        },
                        expression: "data.arrivalStation",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-4" },
        [
          _c("IcFormRowWrapper", {
            attrs: {
              rowElement: "IcFormRow",
              id: "departureDate",
              name: _vm.name + ".departureDate",
              aria: _vm.$t("aria_required_date"),
              label: _vm.$t("label_departureDate"),
              labelWidth: 4,
              controlWidth: 8,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ validator }) {
                  return [
                    _c("ic-date-picker", {
                      attrs: {
                        id: "departureDate",
                        minDate: _vm.minDate,
                        endDate: _vm.endDate,
                        title: "",
                        aria: "Strzałka w górę dół, następny poprzedni dzień.",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.emitInput1(_vm.data, validator)
                        },
                      },
                      model: {
                        value: _vm.data.departureDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "departureDate", $$v)
                        },
                        expression: "data.departureDate",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-2 form-padding-left" },
        [
          _c("IcFormRowWrapper", {
            attrs: {
              rowElement: "IcFormRow",
              id: "departureTime",
              name: _vm.name + ".departureTime",
              aria: _vm.$t("aria_required_time"),
              label: _vm.$t("label_departureTime"),
              labelWidth: 4,
              controlWidth: 8,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ validator }) {
                  return [
                    _c("IcTimePicker", {
                      attrs: { id: "departureTime" },
                      on: {
                        input: function ($event) {
                          return _vm.emitInput1(_vm.data, validator)
                        },
                      },
                      model: {
                        value: _vm.data.departureTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "departureTime", $$v)
                        },
                        expression: "data.departureTime",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.withTrain
        ? _c(
            "div",
            { staticClass: "col-md-3 form-padding-left" },
            [
              _c("IcFormRowWrapper", {
                attrs: {
                  rowElement: "IcFormRow",
                  id: "trainNo",
                  name: _vm.name + ".trainNo",
                  aria: _vm.$t("aria_required"),
                  label: _vm.$t("label_trainNo"),
                  labelWidth: 4,
                  controlWidth: 8,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ validator }) {
                        return [
                          _c("IcInput", {
                            attrs: { id: "trainNo", maxlength: "50" },
                            on: {
                              input: function ($event) {
                                return _vm.emitInput1(_vm.data, validator)
                              },
                            },
                            model: {
                              value: _vm.data.trainNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "trainNo", $$v)
                              },
                              expression: "data.trainNo",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4272505852
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.withDelay
        ? _c(
            "div",
            { staticClass: "col-md-3" },
            [
              _c("IcFormRowWrapper", {
                attrs: {
                  rowElement: "IcFormRow",
                  id: "delay",
                  name: _vm.name + ".delay",
                  label: _vm.$t("label_connection_delay"),
                  aria: _vm.$t("required"),
                  labelWidth: 4,
                  controlWidth: 8,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ validator }) {
                        return [
                          _c("IcSelect", {
                            attrs: { id: "delay", values: _vm.delayOptions },
                            on: {
                              input: function ($event) {
                                return _vm.emitInput1(_vm.data, validator)
                              },
                            },
                            model: {
                              value: _vm.data.delay,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "delay", $$v)
                              },
                              expression: "data.delay",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3337525202
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm.withTicket
        ? _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("IcFormRowWrapper", {
                attrs: {
                  rowElement: "IcFormRow",
                  id: "ticketNo",
                  name: _vm.name + ".ticketNo",
                  aria: _vm.$t("aria_required"),
                  label: _vm.$t("label_ticketNo"),
                  labelWidth: 4,
                  controlWidth: 8,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ validator }) {
                        return [
                          _c("IcMultipleInput", {
                            attrs: {
                              id: "ticketNo",
                              maxlength: "20",
                              maxinputs: 5,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.emitInput(_vm.data, validator)
                              },
                            },
                            model: {
                              value: _vm.data.ticketNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "ticketNo", $$v)
                              },
                              expression: "data.ticketNo",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3045949640
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.showAlert
      ? _c("div", { staticClass: "mt-4 alert alert-warning" }, [
          _vm.miedzynarodowy
            ? _c("div", {
                domProps: { innerHTML: _vm._s(_vm.$t("icforms_form_01_mn")) },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.miedzynarodowy
            ? _c("div", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("icforms_form_01_local")),
                },
              })
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }